import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { switch_view } from '../../scene';
import { must_view_down_negative_direction } from '../../utility';
import view_x_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/view_x.svg';
import { img } from '@phi/components';
import ViewXTooltip from './ViewXTooltip';

export const ViewXIcon = view_x_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon;
        },

        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'Switch view down the X axis';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                switch_view('x', must_view_down_negative_direction('x'));
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: false,
            id: 'view-x-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(view_x_svg, this.alt),
            tooltip: ViewXTooltip,
        });
    }
});
